<fs-sidenav-menu-items>
  <div
      fs-sidenav-menu-item
      *fsAclRead="[{ permission: AclPermission.Admin }]"
      (click)="create()">
    Create New Organization
  </div>
  @if (canSwitchOrganization) {
    <div
        fs-sidenav-menu-item
        (click)="switch()">
      Switch Organization
    </div>
  }
</fs-sidenav-menu-items>